import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Minus, Plus } from 'lucide-react';
import { useController } from 'react-hook-form';
import { z } from 'zod';
import { cn } from '@fortem-monorepo/js-utilities';
import { Button, FormLabel, Input, SelectInput } from '@fortem-monorepo/react-ui';
/**
 * This component must be used within a **react-hook-form** context
 * in order to work correctly.
 */
export const LogicHandler = ({ title, handleAddRow, handleRemoveRow, name, control, }) => {
    const { field: { value: logicValue, onChange: onLogicChange }, } = useController({ name: `${name}.logic`, control });
    const { field: { value: matcherValue, onChange: onMatcherChange }, } = useController({ name: `${name}.matcher`, control });
    const { field: { value, onChange }, } = useController({ name: `${name}.value`, control });
    return (_jsxs("div", { className: 'flex items-center gap-2', children: [_jsx("div", { className: 'flex w-20', children: title ? (_jsx(FormLabel, { className: 'font-medium w-full', children: title })) : (_jsx(SelectInput, { size: "sm", defaultValue: 'or', className: cn('w-full'), value: logicValue, onValueChange: (val) => onLogicChange(val), options: [
                        { label: 'OR', value: 'or' },
                        { label: 'AND', value: 'and' },
                    ] })) }), _jsx(SelectInput, { size: "sm", defaultValue: 'contains', className: 'w-[125px]', value: matcherValue, onValueChange: (val) => onMatcherChange(val), options: [
                    { label: 'Starts With', value: 'startswith' },
                    { label: 'Contains', value: 'contains' },
                    { label: 'Ends With', value: 'endswith' },
                    { label: 'Matches', value: 'matches' },
                ] }), _jsx(Input, { inputSize: "sm", className: 'flex-1', value: value, onChange: (e) => {
                    onChange(e.target.value);
                } }), title ? (_jsx(Button, { size: "sm", variant: 'secondary', className: cn('w-min'), type: "button", onClick: () => {
                    if (handleAddRow) {
                        handleAddRow();
                    }
                }, children: _jsx(Plus, {}) })) : (_jsx(Button, { size: "sm", variant: 'secondary', type: "button", className: cn('w-min!', { ['invisible']: !!title }), onClick: () => {
                    if (handleRemoveRow) {
                        handleRemoveRow();
                    }
                }, children: _jsx(Minus, {}) }))] }));
};
export default LogicHandler;
// ---- VALIDATION ----
export const matcherSchema = z.union([
    z.literal('contains'),
    z.literal('matches'),
    z.literal('startswith'),
    z.literal('endswith'),
]);
export const logicSchema = z.union([z.literal('and'), z.literal('or')]);
// A piece of data from a logic handler
export const dataSchema = z.object({
    matcher: matcherSchema,
    logic: logicSchema.optional(),
    value: z.string().nonempty(),
    // .refine((val) => !val.includes(":"), "Value cannot include with a colon")
});
